module.exports = __webpack_public_path__ + "static/img/kjsc.57ce8546.png";